export const renderNumericValue = (value) =>
  typeof value === "number" ? value : "--";
